export class CasesFilter {
  fromDate: Date;
  toDate: Date;
  filteringText: string;
  supplierProfileId: string | null;

  public constructor(init?: Partial<CasesFilter>) {
    Object.assign(this, init);
  }
}
